import { Check } from "untitledui-js-base";
import { StepNames } from "../constants";
import { Step } from "../types";
import { cx } from "shared/utils";
import { Applicant, ApplicantType } from "shared/types";
import { getApplicantRole } from "utils/getApplicantRole";

export const Aside = ({
  stepNames,
  allSteps,
  activeStepName,
  applicant,
  desiredMoveInDate,
  isSubmissionSentByEmail
}: {
  stepNames: string[];
  allSteps?: Record<string, Step>;
  activeStepName: string;
  applicant: Applicant;
  desiredMoveInDate?: string | null;
  isSubmissionSentByEmail?: boolean;
}) => {
  const idxOfSubmissionDisclosure = stepNames.indexOf(
    "submission_disclosure_step"
  );
  const isSubmissionDisclosureFinished =
    isSubmissionSentByEmail ||
    Object.keys(allSteps?.["submission_disclosure_step"]?.data || {}).length;

  return (
    <div className="max-w-[250px] w-full shrink-0">
      <div className="h-[92px] border-b border-alpha-40 p-6 pr-2">
        <h2 className="truncate text-base font-medium text-content-1000 mb-1">
          {applicant.first_name} {applicant.last_name}
        </h2>

        {/* Role */}
        <p className="text-xs text-content-400">
          {getApplicantRole(applicant.role as ApplicantType)}
        </p>
      </div>
      <div className="space-y-0.5 p-4 overflow-y-auto max-h-[calc(80vh-92px)]">
        {stepNames.map((stepName) => {
          const screenData = allSteps?.[stepName].data;
          // TODO: this is not correct
          // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
          const isFinished =
            (stepName === "move_in_date" && desiredMoveInDate) ||
            (stepName === "submission_disclosure_step" &&
              isSubmissionSentByEmail) ||
            Object.keys(screenData || {}).length;

          const isActive = stepName === activeStepName;

          const currentStepIdx = stepNames.indexOf(stepName);

          const tosIsRequired =
            currentStepIdx > idxOfSubmissionDisclosure &&
            !isSubmissionDisclosureFinished;

          return (
            <div
              onClick={() => {
                if (tosIsRequired) return;

                // Temp disabled
                // setActiveStepName(stepName);
              }}
              className={cx(
                "pr-3 pl-1 rounded text-xs text-content-500 font-medium items-center flex gap-2 hover:bg-alpha-40 py-2",
                tosIsRequired
                  ? "cursor-not-allowed opacity-50"
                  : "cursor-pointer"
              )}
              key={stepName}
            >
              {isActive ? (
                <div className="h-5 w-5 bg-primary-50 border border-primary-500 rounded-full flex items-center justify-center">
                  <div className="h-2 w-2 bg-primary-500 border-white rounded-full" />
                </div>
              ) : isFinished ? (
                <div className="h-5 w-5 bg-primary-500 rounded-full flex items-center justify-center">
                  <Check size="10" className="stroke-white" strokeWidth={4} />
                </div>
              ) : (
                <div className="h-5 w-5 bg-white border border-alpha-100 rounded-full flex items-center justify-center" />
              )}
              {StepNames[stepName]}
            </div>
          );
        })}
      </div>
    </div>
  );
};
